module.exports = __webpack_public_path__ + "static/media/04.185b3ea3.png";